import { reactive } from 'vue';

export const criarEntidade = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        cdentidade: 0,
        nmentidade: '',
        cpfcnpj: '',
        endereco: '',
        nmendereco: 0,
        complemento: '',
        nmbairro: '',
        cep: '',
        fone: '',
        email: '',
        nmcontato: '',
        ckativo: 'S',
        idlogin: 0,
        idusuario: 0
    });
}